<template>
  <div id="app" :style="bgType">
    <div class="commonNav flex-basic" v-if="$route.name != 'login'">
      <!-- <img class="commonLogo" src="~@/assets/image/u139.png" /> -->
      <!-- <img class="commonTitle" src="~@/assets/image/logo.png" /> -->
      <!-- <div class="logo-title">文旅大模型数据状态看板</div> -->
      <div class="head-navs">
        <div
          v-for="(item, index) in navList"
          :key="index"
          class="nav-item"
          :class="activeNavIndex == index ? 'active' : ''"
          @click="handleClickNav(index)"
        >
          {{ item }}
        </div>
      </div>
      <div class="timeWeather flex-basic">
        <div class="time flex-basic">
          <div class="timeLeft border">[</div>
          <div class="main">
            <div class="clock">{{ time }}</div>
            <div class="date">{{ date }}</div>
          </div>
          <div class="timeRight border">]</div>
        </div>
        <div class="weather flex-basic">
          <div class="border">[</div>
          <div class="main flex-basic">
            <div class="temp">{{ maxTemp }}<span> ℃</span></div>
            <img src="~@/assets/image/u150.svg" />
            <div class="windy">
              <div>{{ weatherType }}</div>
              <div>{{ windDir }}</div>
            </div>
          </div>
          <div class="border">]</div>
        </div>
      </div>

      <!-- <div class="tabs flex-basic">
        <div
          class="item"
          :class="tabsIndex == 1 ? 'itemAc' : ''"
          @click="goScenic"
          v-show="false"
        >
          景区大数据
          <div class="child first" v-show="tabsIndex == 1">
            <div
              v-for="(tab, index) in tabList"
              :key="index"
              class="child1"
              :class="{ active: currentView == tab.value }"
              @click.stop="handleClickTab(tab, index)"
            >
              {{ tab.label }}
            </div>
          </div>
        </div>
        <div
          class="item"
          :class="tabsIndex == 2 ? 'itemAc' : ''"
          @click="goGlobl"
          v-show="false"
        >
          全域大数据
          <div class="child" v-show="tabsIndex == 2">
            <div
              v-for="(tab, index) in tabList1"
              :key="index"
              class="child1"
              :class="{ active: currentView1 == tab.value }"
              @click.stop="handleClickTab1(tab, index)"
            >
              {{ tab.label }}
            </div>
          </div>
        </div>
        <div
          class="item"
          :class="tabsIndex == 3 ? 'itemAc' : ''"
          @click="goIndex"
          v-show="false"
        >
          三遗文化
        </div>
      </div> -->
    </div>
    <div class="right-menu">
      <div class="right-menu-item"></div>
    </div>
    <router-view />
  </div>
</template>
<script>
import { getDate, getTime } from "@/tool/dateTool";
import { mapState, mapMutations, mapGetters } from "vuex";
import apis from "@/api/index";
export default {
  name: "app",
  data() {
    return {
      activeNavIndex: 0,
      navList: ["首页", "文旅要素", "文化遗产"],
      tabsIndex: 2,
      date: null,
      time: null,
      currentView: "",
      currentView1: "",
      tabList: [
        {
          label: "景区概述",
          value: "Summary",
        },
        {
          label: "景区客流",
          value: "PassengerFlow",
        },
        {
          label: "景区营销",
          value: "Marketing",
        },
        {
          label: "景区管理",
          value: "administer",
        },
        {
          label: "景区服务",
          value: "Service",
        },
      ],
      tabList1: [
        {
          label: "游客客流",
          value: "globalBigData",
        },
        {
          label: "游客画像",
          value: "touristPortrait",
        },
        {
          label: "游客来源",
          value: "wisdomQingChengShan",
        },
        {
          label: "旅游消费",
          value: "touristConsumption",
        },
      ],
      rightMenus: [
        {
          name: "项目和传承人统计",
          url: "https://szbhpt.tsichuan.com/museum_sc/statistics/projectinheritor/xmccr.html",
        },
        {
          name: "文化生态保护区",
          url: "https://szbhpt.tsichuan.com/feiyi/html/stbhq.html",
        },
        {
          name: "非遗旅游",
          url: "https://szbhpt.tsichuan.com/feiyi/html/fyzl.html",
        },
      ],
      maxTemp: 0,
      weatherType: "",
      windDir: "",
    };
  },
  computed: {
    ...mapState({
      currentComponent: (state) => state.currentView,
    }),
    bgType: function () {
      if (this.$route.meta.bgType) {
        return {
          background: `url('${require(`@/assets/image/bgtype${this.$route.meta.bgType}.jpg`)}') no-repeat 100%`,
        };
      }
    },
  },
  methods: {
    ...mapMutations(["SET_CURRENTVIEW"]),
    async getWeather() {
      const { data } = await apis.getWeather();
      this.maxTemp = data.data.temp;
      this.weatherType = data.data.text;
      this.windDir = data.data.windDir;
      // console.log(data.forecast[0]);
    },
    handleClickNav(index) {
      this.activeNavIndex = index;
      switch (index) {
        case 0:
          this.$router.replace("/scenicSpotBigData");
          break;
        case 1:
          this.$router.replace("/wlys");
          break;
        case 2:
          this.$router.push("/fydata");
          break;
      }
    },
    goIndex() {
      this.tabsIndex = 3;
      sessionStorage.setItem("tabsIndex", 3);
      this.$router.push("/intangibleHeritage");
      this.currentView1 = "intangibleHeritage";
    },
    goGlobl() {
      this.tabsIndex = 2;
      sessionStorage.setItem("tabsIndex", 2);
      this.$router.push("/globalBigData");
      this.currentView1 = "globalBigData";
    },
    goScenic() {
      this.tabsIndex = 1;
      sessionStorage.setItem("tabsIndex", 1);
      this.$router.push("/scenicSpotBigData");
      this.currentView1 = "scenicSpotBigData";
      this.SET_CURRENTVIEW("Summary");
    },
    handleClickTab(tab, index) {
      this.activeIndex = index;
      this.currentView = tab.value;
      this.SET_CURRENTVIEW(this.currentView);
    },
    handleClickTab1(tab) {
      this.currentView1 = tab.value;
      this.$router.push(tab.value);
      sessionStorage.setItem("currentView1", tab.value);
    },
  },
  created() {
    this.getWeather();
    setInterval(() => {
      this.getWeather();
    }, 1000 * 60 * 60);
    if (!sessionStorage.getItem("currentView")) {
      this.SET_CURRENTVIEW("Summary");
    }
    if (sessionStorage.getItem("tabsIndex")) {
      this.tabsIndex = parseInt(sessionStorage.getItem("tabsIndex"));
    } else {
      this.tabsIndex = 1;
    }
    if (sessionStorage.getItem("currentView1")) {
      this.currentView1 = sessionStorage.getItem("currentView1");
    } else {
      this.currentView1 = "scenicSpotBigData";
    }
  },
  mounted() {
    this.SET_CURRENTVIEW("PassengerFlow");

    this.$router.replace({
      name: "scenicSpotBigData",
    });
    // if (!sessionStorage.getItem("loginYes")) {
    // 	this.$router.replace("/login");
    // } else {
    // 	this.$router.replace({
    // 		name: "scenicSpotBigData",
    // 	});
    // }
    setInterval(() => {
      this.date = getDate();
      this.time = getTime();
    }, 1000);
  },
  watch: {
    currentComponent: {
      handler(newVal) {
        this.currentView = newVal;
      },
      immediate: true,
    },
  },
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

#app {
  height: 1080px;
  width: 1920px;
  // background: url(./assets/image/u3146.svg) no-repeat 100%;
  position: relative;
  overflow: hidden;
  font-family: "微软雅黑";
  .commonNav {
    width: 100%;
    height: 165px;
    position: relative;
    top: 0;
    background-image: url(./assets/image/logo2.png);
    background-position: top;
    background-repeat: no-repeat;
    justify-content: space-between;
    z-index: 2;
    display: block;
    .head-navs {
      flex: 1;
      float: right;
      text-align: right;
      display: flex;
      justify-content: flex-end;
      float: left;
      padding: 15px 0;
      .nav-item {
        float: right;
        color: #9dcaff;
        cursor: pointer;
        padding: 0 20px;
        font-size: 20px;
        border-left: 1px solid #666;
        &.active {
          color: #fff;
        }
        &:hover {
          filter: brightness(1.2);
        }
      }
      .nav-item:nth-child(1) {
        border: none;
      }
    }
    .commonLogo {
      margin-left: 4px;
    }

    .timeWeather {
      float: right;
      margin-left: 60px;
      min-width: 320px;
      .time {
        .border {
          font-weight: 100;
          font-style: normal;
          font-size: 36px;
          color: #9dcaff;
          opacity: 0.5;
        }

        .main {
          padding: 0 10px;

          .clock {
            font-weight: 400;
            font-style: normal;
            font-size: 20px;
            letter-spacing: 0.4px;
            color: #ffffff;
            text-align: center;
          }

          .date {
            font-weight: 400;
            font-style: normal;
            font-size: 12px;
            color: #9dcaff;
            text-align: center;
          }
        }
      }

      .weather {
        margin-left: 30px;

        .border {
          font-weight: 100;
          font-style: normal;
          font-size: 36px;
          color: #9dcaff;
          opacity: 0.5;
        }

        .main {
          padding: 0 10px;
        }

        .temp {
          font-size: 30px;
          color: #fff;

          span {
            font-size: 14px;
          }
        }

        img {
          margin: 0 10px;
        }

        .windy {
          font-weight: 400;
          font-style: normal;
          font-size: 13px;
          color: #9dcaff;
        }
      }
    }

    .tabs {
      position: absolute;
      right: 20px;
      top: 10px;

      .item {
        width: 138px;
        height: 56px;
        line-height: 46px;
        background: url(./assets/image/u141.png) no-repeat 100%;
        text-align: center;
        color: #fff;
        opacity: 0.6;
        cursor: pointer;

        .child {
          position: absolute;
          right: -13px;
          top: 52px;
          height: 50px;
          background-color: #0d223a;
          padding: 8px 10px 10px 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;

          .child1 {
            width: 100px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            font-size: 14px;
            color: rgba(157, 202, 255, 0.6);
            background-image: url("~@/assets/image/scenicSpotBigData/tab_bg_0.png");
            background-size: 100%;
            background-repeat: no-repeat;
            cursor: pointer;
            margin-right: 7px;
            &:last-child {
              margin: 0;
            }
          }

          .active {
            background-image: url("~@/assets/image/scenicSpotBigData/tab_bg_1.png");
            background-size: 100%;
            background-repeat: no-repeat;
            color: #fff;
          }
        }
        .first {
          right: 70px;
          z-index: 99;
        }
      }

      .itemAc {
        opacity: 1;
        background: url(./assets/image/u142.png) no-repeat 100%;
      }
    }
  }
}

#nprogress .spinner {
  position: absolute;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);
  height: 70px !important;
  width: 70px !important;
}

#nprogress .spinner-icon {
  height: 70px !important;
  width: 70px !important;
}
.logo-title {
  color: #fff;
  text-shadow: 0 0 10px #fff;
  font-size: 20px;
}
/* 修改垂直滚动条 */
::-webkit-scrollbar {
  width: 4px; /* 修改宽度 */
}

/* 修改垂直滚动条 */
::-webkit-scrollbar {
  width: 4px; /* 修改宽度 */
  height: 8px;
}

/* 修改滚动条轨道背景色 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 修改滚动条滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #0a3357;
}

/* 修改滚动条滑块悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background-color: rgb(144, 163, 226) cfe;
}
</style>
